// extracted by mini-css-extract-plugin
export default {"detailContainer":"_17WwaCsLLJ_d4SKw0hAaoO"};